<template>
	<v-list density="compact">
		<v-list-item class="list-ChartContextMenu" v-for="(item, index) in itemsForFlatGroundEdit" :key="index"
			@click="onCMClickForFlatGroundEdit($event, item.id)">
			<v-list-item-title>
				{{ $t(item.title) }}
			</v-list-item-title>
		</v-list-item>
	</v-list>
</template>

<script lang="ts">
import { useStore, mapActions, mapState } from "vuex";
import { ObjectType } from "@/models/objects/types";

export default {
	setup() {
		const store = useStore();
		return { store };
	},
	props: {
		flatGroundId: String,
		pointId: String,
	},
	data: () => ({
		isroadOrFlatArea: "Road",
		itemsForFlatGroundEdit: [
			// { id: 1, title: "ADD" },
			{ id: 2, title: "Remove" },
			{ id: 3, title: "Switchdragmode" },
			{ id: 4, title: "Uniformdrag" },
			{ id: 5, title: "Undo" },
			{ id: 6, title: "Redo" },
			{ id: 7, title: "Update" },
			{ id: 8, title: "FLATGROUND_HEIGHT" },
		],
	}),
	computed: {
		...mapState("flatGround", [
			"isFlatGroundHoriDrag",
			"isFlatGroundVertiDrag",
			"isFlatGroundUniformDrag",
		]),
		isEditOnProgress() {
			return this.store.state.object.objectUnderEdit?.id === this.flatGroundId;
		},
	},
	methods: {
		...mapActions("object", ["endEdit"]),
		...mapActions("flatGround", [
			"setIsFlatGroundHoriDrag",
			"setIsFlatGroundVertiDrag",
			"setIsFlatGroundUniformDrag",
		]),
		addControlPoint() {
			// window["viewer"].toggleFlatGroundPointVerticalDrag(
			//   false,
			//   this.flatGroundId
			// );
			// window["viewer"].toggleFlatGroundPointDrag(
			//   true,
			//   this.flatGroundId,
			//   () => { uploadFlatGroundObj(obj) }
			// );
			// window["viewer"].addMidPointsForFlatGround(
			//   this.flatGroundId
			// );
		},
		removeControlPoint() {
			window["viewer"].removePointFromFlatGround(
				this.flatGroundId,
				this.pointId,
			);
		},
		switchToDragMode() {
			this.setIsFlatGroundHoriDrag(false);
			this.setIsFlatGroundUniformDrag(false);
			this.setIsFlatGroundVertiDrag(!this.isFlatGroundVertiDrag);

			if (this.isFlatGroundVertiDrag) {
				this.$store.dispatch("setCurrentView", "3d");
				this.store.getters.viewer.setFlatGroundPointToVerticalDrag(
					this.flatGroundId,
				);
			} else {
				this.setIsFlatGroundHoriDrag(true);
				this.store.getters.viewer.setFlatGroundPointToHorizontalDrag(
					this.flatGroundId,
				);
			}
		},
		openPropertyDialogUpdateControlPoint(disabilityConditions = "NONE") {
			window.dispatchEvent(
				new CustomEvent("openPropertyDialog", {
					detail: {
						id: this.flatGroundId,
						type: 3,
						pointId: this.pointId,
						entityUnderEdit: ObjectType.FLAT_GROUND,
						disabilityConditions,
						origin: "CesiumView",
					},
				}),
			);
		},
		uniformlyDragFlatGround() {
			if (this.isEditOnProgress) {
				this.setIsFlatGroundHoriDrag(false);
				this.setIsFlatGroundVertiDrag(false);
				this.setIsFlatGroundUniformDrag(!this.isFlatGroundUniformDrag);

				if (this.isFlatGroundUniformDrag) {
					this.$store.dispatch("setCurrentView", "3d");
					this.store.getters.viewer.setFlatGroundToUniformVerticalDrag(
						this.flatGroundId,
					);
				} else {
					this.setIsFlatGroundHoriDrag(true);
					this.store.getters.viewer.setFlatGroundPointToHorizontalDrag(
						this.flatGroundId,
					);
				}
			}
		},
		onCMClickForFlatGroundEdit(e, id) {
			e.preventDefault();
			this.isroadOrFlatArea = "FlatArea";
			switch (id) {
				// case 1:
				//   this.addControlPoint(obj);
				//   break;
				case 2:
					this.removeControlPoint();
					break;
				case 3:
					this.switchToDragMode();
					break;
				case 4:
					this.uniformlyDragFlatGround();
					break;
				case 5:
					this.store.getters.viewer.undo();
					break;
				case 6:
					this.store.getters.viewer.redo();
					break;
				case 7:
					this.openPropertyDialogUpdateControlPoint("NONE");
					break;
				case 8:
					this.openPropertyDialogUpdateControlPoint("XY");
					break;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.list-ChartContextMenu:hover {
	background-color: #0064ba !important;
}
</style>
